<template>
  <div class="flex">
    <a-input class="mr-4" placeholder="Index name" v-model="indexName" />
    <a-button
      type="primary"
      :disabled="isCreateButtonDisabled"
      :loading="isCreating"
      @click="createIndex()"
    >
      Create Index
    </a-button>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import EventBus from '../../event-bus/EventBus'

export default {
  props: {
    inceptionYear: {
      type: Number,
      default: 2021,
    },
    inceptionMonth: {
      type: Number,
      default: 1,
    },
    constituents: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      indexName: '',
      isCreating: false,
    }
  },
  computed: {
    isCreateButtonDisabled() {
      return !this.indexName || this.isCreating
    },
  },
  methods: {
    async createIndex() {
      this.isCreating = true
      let result
      try {
        result = await this.$apollo.mutate({
          mutation: gql`
            mutation CreateIndex($input: CreateIndexInput) {
              createIndex(input: $input) {
                id
              }
            }
          `,
          variables: {
            input: {
              name: this.indexName,
              inceptionYear: this.inceptionYear,
              inceptionMonth: this.inceptionMonth,
              constituents: this.constituents.map((c) => ({
                classKey: c.class.key,
                className: c.class.name,
                fundKey: c.fund.key,
                fundName: c.fund.name,
              })),
            },
          },
        })
      } catch (error) {
        this.$message.error(error.message)
        this.isCreating = false
        return
      }
      this.isCreating = false
      const indexId = result.data.createIndex.id
      this.$router.push(`/index/custom/${indexId}`)
      EventBus.$emit('indexCreated', { id: indexId })
    },
  },
}
</script>

<style></style>
